import { render, staticRenderFns } from "./BtoC.vue?vue&type=template&id=44cd9899&scoped=true&"
import script from "./BtoC.vue?vue&type=script&lang=js&"
export * from "./BtoC.vue?vue&type=script&lang=js&"
import style0 from "./BtoC.vue?vue&type=style&index=0&id=44cd9899&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cd9899",
  null
  
)

export default component.exports